import { render, staticRenderFns } from "./ListAppointments.vue?vue&type=template&id=a83789fc"
import script from "./ListAppointments.vue?vue&type=script&lang=js"
export * from "./ListAppointments.vue?vue&type=script&lang=js"
import style0 from "./ListAppointments.vue?vue&type=style&index=0&id=a83789fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports